<template>
  <form @submit.prevent="handlePaymentMethodSubmission">
    <div v-if="loading">Loading...</div>
    <div id="card-container" />
    <button :disabled="isLab" id="pay-btn">Pay: ${{ allCost }}</button>
  </form>
  <div v-if="paymentStatus" id="payment-status-container">
    {{ paymentStatus }}
  </div>

</template>




<script>

// TODO: CLEAN UP THIS COMPONENT, THIS WAS HACKED TOGETHER
// TODO: CHECK ERROR HANDLING LOGIC

import { ref } from 'vue';


let appId = '';               // this gets passed
const locationId = "main";    // TODO: will need to pull this from the database if we have multiple lab locations... future feature

let card;
let loading = ref(true)
let paymentStatus = ref('')


const initializePaymentForm = async () => {
  if (!Square) {
    throw new Error("Square.js failed to load properly");
  }
  const payments = Square.payments(appId, locationId);
  try {
    card = await payments.card();
    await card.attach("#card-container");
  } catch (e) {
    console.error("Initializing Card failed", e);
    // throw e;
    return;
  }
};


// GLOBALS
// ----------------
// import Square from ('square');
const API = process.env.VUE_APP_API_URL;
const IS_PROD = Number(process.env.VUE_APP_IS_PROD);    // just convert string here
// ----------------


export default {
  name:'SquarePayment',
  components: {},
  props:{
    labOptionsId: String,
    shoppingCart: Object,
    showNotificationCb: Function,
    userId: String,   // this represents if a user is logged in (not guest)
    checkoutUserInfo: Object,    // Object that represents user info from checkout, can be either from guest or user account
    resetDataCb: Function,    // used to close after successful order
    applicationId: String,    // from square app, should be decrypted when it is passed as a prop
    isLab: Boolean,

  },
  data() {
    return {

      card: null,
      loading: false,
      paymentStatus: '',

      canSubmitPayment: true,
    }
  },
  computed: {
    allCost() {
      const { totalCostDollars, taxDollars } = this.shoppingCart;
      return totalCostDollars + ( taxDollars || 0 );
    },

  },
  methods: {

    async tokenize( paymentMethod ) {
      const tokenResult = await paymentMethod.tokenize();

      if (tokenResult.status === "OK") {
        return tokenResult.token;
      } 
      else {
        let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
        if (tokenResult.errors) {
          const otherErrors = tokenResult.errors
            .map( e => e.message )
            .join( ', ' );
          errorMessage += ` and errors: ${otherErrors}`;
        }
        throw new Error(errorMessage);
      }
    },


    // this is called when the pay button is clicked
    async handlePaymentMethodSubmission() {

      if ( !this.canSubmitPayment ) {
        const errData = this.createErrorStructure('Payment fields not loaded correctly. Try again later');
        return this.showNotificationCb( errData );
      }
      window.ShowBackdrop();
      window.ChangeIndex(100);
      paymentStatus.value = "";
      let token;

      try {
        token =  await this.tokenize(card);
      } 
      catch ( tokenizeError ) {
        window.ChangeIndex(50);
        window.HideBackdrop();
        return this.showNotificationCb(
          this.createErrorStructure( tokenizeError.message )
        );
      }

      const data = {
        sourceId: token,
        labOptionsId: this.labOptionsId,
        shoppingCart: this.shoppingCart,
        userId: this.userId,
        checkoutUserInfo: this.checkoutUserInfo,
      };
      
      // make BE call to create order
      const response = await fetch( API + '/api/order/createPaymentSquare', {
        method: 'POST', 
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(data),
      });

      // if custom error notification is sent then handle it here, this means I forced an error in the backend
      if ( response.notification?.msg ) {
        this.showNotificationCb( response );
        window.HideBackdrop();
        return;
      }
      

      if (!response.ok) {
        throw new Error("Payment failed");
      }
      const ret = await response.json();
      paymentStatus.value = "Payment completed";

      this.showNotificationCb( ret )

      window.HideBackdrop( true );
      this.resetDataCb();

      return
    },

    createErrorStructure( msg ) {
      return {
        notification: {
          msg,
          type: 'error',
        }
      };
    },



  },
  async mounted(){
    // disable pay button to prevent accidental clicks
    const el = document.getElementById('pay-btn');
    el.disabled = true;
    
    loading = true;

    // set appId based on prop
    appId = this.applicationId;
    try {
      // now we need to load the appropriate square script (different for prod vs sandbox)
      const script = document.createElement('script');
      script.src = ( IS_PROD )
        ? 'https://web.squarecdn.com/v1/square.js'
        : 'https://sandbox.web.squarecdn.com/v1/square.js';

      // add script tag
      document.head.appendChild(script);

      // once loaded we want to initialize the payment form
      script.onload = async() => {
        try {
          await initializePaymentForm();

          // enable pay button
          if ( !this.isLab) el.disabled=false;
        } catch (error) {
          throw error;
        }
        
      }
      // await initializePaymentForm();
    } 
    catch (error) {
      // flag to stop payment
      this.canSubmitPayment = false;
      this.showNotificationCb( this.createErrorStructure( error.message ) );
    }
    loading = false;
  }
}
</script>


<style scoped>
button {
  color: #ffffff;
  background-color: #006aff;
  border-radius: 6px;
  cursor: pointer;
  border-style: none;
  font-size: 16px;
  line-height: 24px;
  padding: 12px 16px;
  width: 100%;
}

button:hover {
  background-color: #005fe5;
}

button:active {
  background-color: #0055cc;
}

button:disabled {
  background-color: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.3);
}

#payment-status-container {
  width: fit-content;
  font-family: Arial, Helvetica, sans-serif;
  color: #ffffff;
  background: #1a1a1a;
  display: flex;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1), 0px 0px 4px rgba(0, 0, 0, 0.1);
  margin: auto;
  margin-top: 36px;
}
</style>